import React from 'react';

// Couleurs du thème SmartBouffe
const colors = {
  primary: '#87A96B',    // Vert sauge
  secondary: '#D4A574',  // Doré
  dark: '#3A4A3E',      // Vert foncé
  warning: '#FFA726',   // Orange
  error: '#DC3545',     // Rouge
  success: '#4CAF50',   // Vert succès
};

// Chef - remplace 🧑‍🍳
export const ChefIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C10.5 2 9 2.5 8 3.5C7 2.5 5.5 2 4 2C2.5 2 1 3 1 5C1 7 2 8 3 8.5V20C3 21 4 22 5 22H19C20 22 21 21 21 20V8.5C22 8 23 7 23 5C23 3 21.5 2 20 2C18.5 2 17 2.5 16 3.5C15 2.5 13.5 2 12 2Z" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 10H17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 14H16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Warning - remplace ⚠️
export const WarningIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 20H22L12 2Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 9V13" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="17" r="1" fill={color}/>
  </svg>
);

// Delete/Trash - remplace 🗑️
export const DeleteIcon = ({ size = 24, color = colors.error }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 6H21" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 11V17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14 11V17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Edit - remplace ✏️
export const EditIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 3L21 7L9 19H5V15L17 3Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 6L18 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Camera/Photo - remplace 📸
export const CameraIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="6" width="20" height="14" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M7 6L9 3H15L17 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="13" r="3" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Success/Celebration - remplace 🎉
export const CelebrationIcon = ({ size = 24, color = colors.success }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L14 8L20 10L14 12L12 18L10 12L4 10L10 8L12 2Z" fill={color} stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M6 3L7 5L9 6" stroke={colors.warning} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M18 3L17 5L15 6" stroke={colors.secondary} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M6 18L7 20L9 21" stroke={colors.warning} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M18 18L17 20L15 21" stroke={colors.secondary} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Check/Success - remplace ✅
export const CheckIcon = ({ size = 24, color = colors.success }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5"/>
    <path d="M8 12L11 15L16 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Close/Error - remplace ❌
export const CloseIcon = ({ size = 24, color = colors.error }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5"/>
    <path d="M9 9L15 15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M15 9L9 15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Fleur de lys Québec - remplace ⚜️
export const FleurDeLysIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C12 2 10 4 10 6C10 7 11 8 12 8C13 8 14 7 14 6C14 4 12 2 12 2Z" fill={color}/>
    <path d="M12 8C12 8 9 9 7 11C6 12 6 13 7 14C8 15 9 15 10 14C12 12 12 8 12 8Z" fill={color}/>
    <path d="M12 8C12 8 15 9 17 11C18 12 18 13 17 14C16 15 15 15 14 14C12 12 12 8 12 8Z" fill={color}/>
    <path d="M12 14L10 22H14L12 14Z" fill={color}/>
    <ellipse cx="12" cy="14" rx="2" ry="3" fill={color}/>
  </svg>
);

// Fire - remplace 🔥
export const FireIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8 6 6 10 6 13C6 17 9 20 12 20C15 20 18 17 18 13C18 10 16 6 12 2Z" 
          fill={color} opacity="0.3"/>
    <path d="M12 2C8 6 6 10 6 13C6 17 9 20 12 20C15 20 18 17 18 13C18 10 16 6 12 2Z" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8C10 10 9 12 9 14C9 16 10 17 12 17C14 17 15 16 15 14C15 12 14 10 12 8Z" 
          fill="#FFF" opacity="0.6"/>
  </svg>
);

// Clock/Time - remplace ⏰
export const ClockIcon = ({ size = 24, color = colors.dark }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5"/>
    <path d="M12 6V12L15 15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Meal/Plate - remplace 🍽️
export const MealIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="8" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="5" stroke={color} strokeWidth="1.5"/>
    <path d="M12 4V2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 22V20" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4 12H2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M22 12H20" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// === ALLERGÈNES ===

// Peanuts - remplace 🥜
export const PeanutIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8C8 5 10 3 12 3C14 3 16 5 16 8C16 9 15.5 10 15 11C16 11 17 12 17 14C17 16 15 18 13 18C11 18 10 17 10 16C8 16 7 14 7 12C7 11 7.5 10 8 9C7.5 9 8 8.5 8 8Z" 
          fill={color} opacity="0.3"/>
    <path d="M8 8C8 5 10 3 12 3C14 3 16 5 16 8C16 9 15.5 10 15 11C16 11 17 12 17 14C17 16 15 18 13 18C11 18 10 17 10 16C8 16 7 14 7 12C7 11 7.5 10 8 9C7.5 9 8 8.5 8 8Z" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 14L14 10" stroke={color} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

// Dairy/Milk - remplace 🥛
export const DairyIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 2H16L17 6H7L8 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M7 6H17V19C17 20.5 15.5 22 14 22H10C8.5 22 7 20.5 7 19V6Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M10 10H14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 14H14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Fish - remplace 🐟
export const FishIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 12C2 12 4 8 8 8C10 8 11 9 12 10C13 9 14 8 16 8C20 8 22 12 22 12C22 12 20 16 16 16C14 16 13 15 12 14C11 15 10 16 8 16C4 16 2 12 2 12Z" 
          fill={color} opacity="0.2"/>
    <path d="M2 12C2 12 4 8 8 8C10 8 11 9 12 10C13 9 14 8 16 8C20 8 22 12 22 12C22 12 20 16 16 16C14 16 13 15 12 14C11 15 10 16 8 16C4 16 2 12 2 12Z" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="11" r="1" fill={color}/>
    <path d="M12 10V14" stroke={color} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

// Shellfish - remplace 🦐
export const ShellfishIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 14C8 14 6 12 6 10C6 8 7 6 9 6C10 6 11 6.5 12 7C13 6.5 14 6 15 6C17 6 18 8 18 10C18 12 16 14 16 14" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 14C8 16 10 18 12 18C14 18 16 16 16 14" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 7V18" stroke={color} strokeWidth="1" strokeLinecap="round"/>
    <circle cx="10" cy="10" r="0.5" fill={color}/>
    <circle cx="14" cy="10" r="0.5" fill={color}/>
  </svg>
);

// Eggs - remplace 🥚
export const EggIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="13" rx="6" ry="8" fill={color} opacity="0.2"/>
    <ellipse cx="12" cy="13" rx="6" ry="8" stroke={color} strokeWidth="1.5"/>
    <path d="M9 10C9 10 10 9 12 9C14 9 15 10 15 10" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

// Wheat/Gluten - remplace 🌾
export const WheatIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2V22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 4C10 4 9 5 9 6C9 7 10 8 12 8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 4C14 4 15 5 15 6C15 7 14 8 12 8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 8C10 8 9 9 9 10C9 11 10 12 12 12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 8C14 8 15 9 15 10C15 11 14 12 12 12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 12C10 12 9 13 9 14C9 15 10 16 12 16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 12C14 12 15 13 15 14C15 15 14 16 12 16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Tree Nuts - remplace 🌰
export const TreeNutIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3C9 3 7 5 7 8C7 11 9 13 12 13C15 13 17 11 17 8C17 5 15 3 12 3Z" 
          fill={color} opacity="0.3"/>
    <path d="M12 3C9 3 7 5 7 8C7 11 9 13 12 13C15 13 17 11 17 8C17 5 15 3 12 3Z" 
          stroke={color} strokeWidth="1.5"/>
    <path d="M10 13C10 13 8 15 8 18C8 20 10 22 12 22C14 22 16 20 16 18C16 15 14 13 14 13" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 6V10" stroke={color} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

// Move Arrow - remplace ➡️
export const MoveIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12H21" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M15 6L21 12L15 18" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Users/People - remplace 👥
export const UsersIcon = ({ size = 24, color = colors.dark }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="7" r="3" stroke={color} strokeWidth="1.5"/>
    <circle cx="15" cy="7" r="3" stroke={color} strokeWidth="1.5"/>
    <path d="M3 19C3 16 6 14 9 14C12 14 15 16 15 19" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M9 19C9 16 12 14 15 14C18 14 21 16 21 19" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// === RÉGIMES ALIMENTAIRES ===

// Vegetarian - remplace 🥗
export const VegetarianIcon = ({ size = 24, color = colors.success }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C7 22 3 18 3 13C3 8 7 4 12 4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 4C12 4 16 8 16 13C16 18 12 22 12 22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 4V22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="12" cy="6" r="2" fill={color} opacity="0.3"/>
  </svg>
);

// Vegan - remplace 🌱
export const VeganIcon = ({ size = 24, color = colors.success }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8 2 4 6 4 10C4 14 8 18 12 22C16 18 20 14 20 10C20 6 16 2 12 2Z" 
          fill={color} opacity="0.2"/>
    <path d="M12 2C8 2 4 6 4 10C4 14 8 18 12 22C16 18 20 14 20 10C20 6 16 2 12 2Z" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8V16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M9 11L12 8L15 11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Carnivore - remplace 🥩
export const CarnivoreIcon = ({ size = 24, color = colors.error }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 8C6 6 8 4 10 4C12 4 14 6 14 8V12H10C8 12 6 10 6 8Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M14 8C14 6 16 4 18 4C20 4 22 6 22 8C22 10 20 12 18 12H14V8Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M6 14H18V18C18 20 16 22 14 22H10C8 22 6 20 6 18V14Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

// Keto - remplace 🥑
export const KetoIcon = ({ size = 24, color = colors.success }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="13" rx="7" ry="9" fill={color} opacity="0.2"/>
    <ellipse cx="12" cy="13" rx="7" ry="9" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="13" r="3" fill="#8B7355" stroke={color} strokeWidth="1"/>
    <path d="M12 4C12 4 15 6 15 8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Paleo - remplace 🍖
export const PaleoIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 10C8 8 10 6 12 6C14 6 16 8 16 10V16H8V10Z" 
          fill={color} opacity="0.3"/>
    <path d="M8 10C8 8 10 6 12 6C14 6 16 8 16 10V16H8V10Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M6 16H18V18C18 19 17 20 16 20H8C7 20 6 19 6 18V16Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <line x1="10" y1="6" x2="10" y2="4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="14" y1="6" x2="14" y2="4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Low Carb - remplace 🍞
export const LowCarbIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="8" width="16" height="12" rx="2" fill={color} opacity="0.2"/>
    <rect x="4" y="8" width="16" height="12" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M4 12H20" stroke={color} strokeWidth="1" strokeLinecap="round"/>
    <circle cx="9" cy="10" r="1" fill={color}/>
    <circle cx="15" cy="10" r="1" fill={color}/>
    <circle cx="12" cy="15" r="1" fill={color}/>
    <path d="M6 8V6C6 5 7 4 8 4H16C17 4 18 5 18 6V8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="6" y1="4" x2="18" y2="20" stroke={colors.error} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Halal - remplace ☪️
export const HalalIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3C8 7 6 11 6 14C6 18 9 21 12 21C15 21 18 18 18 14C18 11 16 7 12 3Z" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="16" cy="8" r="3" stroke={color} strokeWidth="1.5"/>
    <path d="M12 10V16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Kosher - remplace ✡️
export const KosherIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L15 8L21 10L15 12L12 18L9 12L3 10L9 8L12 2Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M12 6L14 10L18 12L14 14L12 18L10 14L6 12L10 10L12 6Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

// Soy - remplace 🫘
export const SoyIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="8" cy="12" rx="3" ry="5" fill={color} opacity="0.3"/>
    <ellipse cx="8" cy="12" rx="3" ry="5" stroke={color} strokeWidth="1.5"/>
    <ellipse cx="16" cy="12" rx="3" ry="5" fill={color} opacity="0.3"/>
    <ellipse cx="16" cy="12" rx="3" ry="5" stroke={color} strokeWidth="1.5"/>
    <path d="M12 6C12 6 14 8 14 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Sesame - remplace 🫘
export const SesameIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="12" rx="6" ry="8" stroke={color} strokeWidth="1.5"/>
    <circle cx="10" cy="9" r="1" fill={color}/>
    <circle cx="14" cy="9" r="1" fill={color}/>
    <circle cx="12" cy="12" r="1" fill={color}/>
    <circle cx="10" cy="15" r="1" fill={color}/>
    <circle cx="14" cy="15" r="1" fill={color}/>
  </svg>
);

// Sulfites - remplace 🍇
export const SulfitesIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="12" r="3" fill={color} opacity="0.3"/>
    <circle cx="8" cy="12" r="3" stroke={color} strokeWidth="1.5"/>
    <circle cx="14" cy="10" r="2.5" fill={color} opacity="0.3"/>
    <circle cx="14" cy="10" r="2.5" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="16" r="2.5" fill={color} opacity="0.3"/>
    <circle cx="12" cy="16" r="2.5" stroke={color} strokeWidth="1.5"/>
    <circle cx="16" cy="15" r="2" fill={color} opacity="0.3"/>
    <circle cx="16" cy="15" r="2" stroke={color} strokeWidth="1.5"/>
    <path d="M10 6C10 6 11 4 12 3" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Video Camera - remplace 📹 🎥 🎬
export const VideoIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="6" width="14" height="12" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M16 10L22 7V17L16 14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill={color} fillOpacity="0.2"/>
    <circle cx="9" cy="12" r="2" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Gift - remplace 🎁
export const GiftIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="10" width="18" height="12" rx="1" stroke={color} strokeWidth="1.5"/>
    <path d="M3 10H21V14H3V10Z" fill={color} opacity="0.2"/>
    <path d="M12 10V22" stroke={color} strokeWidth="1.5"/>
    <path d="M12 4C12 4 10 6 10 8C10 9 11 10 12 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 4C12 4 14 6 14 8C14 9 13 10 12 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M7 10C7 8 9 6 10 6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17 10C17 8 15 6 14 6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Clapperboard - remplace 🎬
export const ClapperboardIcon = ({ size = 24, color = colors.dark }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="6" width="20" height="14" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M2 10H22" stroke={color} strokeWidth="1.5"/>
    <path d="M7 6L5 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 6L10 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17 6L15 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Breakfast - remplace 🍳
export const BreakfastIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="14" rx="7" ry="6" fill={color} opacity="0.2"/>
    <ellipse cx="12" cy="14" rx="7" ry="6" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="13" r="3" fill="#FFF" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="13" r="1.5" fill={colors.warning}/>
    <path d="M8 8C8 8 10 6 12 6C14 6 16 8 16 8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Person/User - remplace 👤
export const PersonIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="7" r="4" stroke={color} strokeWidth="1.5"/>
    <path d="M5 20C5 16 8 13 12 13C16 13 19 16 19 20" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Key - remplace 🔑
export const KeyIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="4" stroke={color} strokeWidth="1.5"/>
    <circle cx="7" cy="7" r="2" stroke={color} strokeWidth="1.5"/>
    <path d="M10 10L20 20" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M16 20H20" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M18 18V22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Save/Floppy - remplace 💾
export const SaveIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="1.5"/>
    <rect x="7" y="3" width="10" height="7" fill={color} opacity="0.2"/>
    <rect x="7" y="3" width="10" height="7" stroke={color} strokeWidth="1.5"/>
    <rect x="7" y="13" width="10" height="8" rx="1" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Megaphone - remplace 📢
export const MegaphoneIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 8L20 4V20L4 16V8Z" fill={color} opacity="0.2"/>
    <path d="M4 8L20 4V20L4 16V8Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 12H2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M7 16L6 20L9 19L8 16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Calendar - remplace 📅
export const CalendarIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="16" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M3 9H21" stroke={color} strokeWidth="1.5"/>
    <path d="M7 3V7" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17 3V7" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="8" cy="13" r="1" fill={color}/>
    <circle cx="12" cy="13" r="1" fill={color}/>
    <circle cx="16" cy="13" r="1" fill={color}/>
  </svg>
);

// Fork and Knife - remplace 🍴
export const ForkKnifeIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 3V10C9 11 8 12 7 12V22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M7 3V10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M5 3V10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17 3V8C17 9 16 10 15 10V22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M19 3V8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Door/Logout - remplace 🚪
export const DoorIcon = ({ size = 24, color = colors.error }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="2" width="12" height="20" rx="1" stroke={color} strokeWidth="1.5"/>
    <path d="M6 2H4C3 2 2 3 2 4V20C2 21 3 22 4 22H6" stroke={color} strokeWidth="1.5"/>
    <circle cx="14" cy="12" r="1" fill={color}/>
    <path d="M18 12H22M22 12L20 10M22 12L20 14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Star - remplace ⭐
export const StarIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" 
          fill={color} stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

// Chart/Statistics - remplace 📊
export const ChartIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M8 16V11" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 16V8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M16 16V13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Comment/Chat - remplace 💬
export const CommentIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 11C21 16 17 20 12 20L4 22V11C4 6 8 2 13 2C17 2 21 6 21 11Z" 
          fill={color} opacity="0.2"/>
    <path d="M21 11C21 16 17 20 12 20L4 22V11C4 6 8 2 13 2C17 2 21 6 21 11Z" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="11" r="1" fill={color}/>
    <circle cx="13" cy="11" r="1" fill={color}/>
    <circle cx="17" cy="11" r="1" fill={color}/>
  </svg>
);

// Refresh - remplace 🔄
export const RefreshIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 12C21 16.5 17 20.5 12 20.5C7 20.5 3 16.5 3 12C3 7.5 7 3.5 12 3.5C15 3.5 17.5 5 19 7" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M19 3V7H15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Upload/Share - remplace 📤
export const UploadIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 17V19C4 20 5 21 6 21H18C19 21 20 20 20 19V17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 3V15" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 7L12 3L16 7" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Plus/Add - remplace ➕
export const PlusIcon = ({ size = 24, color = colors.success }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5"/>
    <path d="M12 8V16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 12H16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Download - remplace 📥
export const DownloadIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 17V19C4 20 5 21 6 21H18C19 21 20 20 20 19V17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 3V15" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 11L12 15L16 11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Spoon - remplace 🥄
export const SpoonIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="7" rx="4" ry="5" fill={color} opacity="0.2"/>
    <ellipse cx="12" cy="7" rx="4" ry="5" stroke={color} strokeWidth="1.5"/>
    <path d="M12 12V22" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Note/Document - remplace 📝
export const NoteIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C5 2 4 3 4 4V20C4 21 5 22 6 22H18C19 22 20 21 20 20V8L14 2Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M14 2V8H20" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M8 13H16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 17H16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Eye - remplace 👁️
export const EyeIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// EyeOff - œil barré pour cacher le mot de passe
export const EyeOffIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 12C2 12 5 5 12 5C13.5 5 14.9 5.3 16.2 5.8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M22 12C22 12 19 19 12 19C10.5 19 9.1 18.7 7.8 18.2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M9.5 14.5C8.9 13.9 8.5 13 8.5 12C8.5 10 10 8.5 12 8.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14.5 9.5C15.1 10.1 15.5 11 15.5 12C15.5 14 14 15.5 12 15.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4 4L20 20" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Diamond - remplace 💎
export const DiamondIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 9L12 22L22 9L12 2Z" fill={color} opacity="0.2"/>
    <path d="M12 2L2 9L12 22L22 9L12 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M2 9H22" stroke={color} strokeWidth="1.5"/>
    <path d="M12 2V22" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Settings/Gear - remplace ⚙️
export const SettingsIcon = ({ size = 24, color = colors.dark }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5"/>
    <path d="M12 2V4M12 20V22M4 12H2M22 12H20M5.6 5.6L4.2 4.2M19.8 19.8L18.4 18.4M5.6 18.4L4.2 19.8M19.8 4.2L18.4 5.6" 
          stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Lightbulb - remplace 💡
export const LightbulbIcon = ({ size = 24, color = colors.warning }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8 2 5 5 5 9C5 12 7 14 8 16V18C8 19 9 20 10 20H14C15 20 16 19 16 18V16C17 14 19 12 19 9C19 5 16 2 12 2Z" 
          fill={color} opacity="0.2"/>
    <path d="M12 2C8 2 5 5 5 9C5 12 7 14 8 16V18C8 19 9 20 10 20H14C15 20 16 19 16 18V16C17 14 19 12 19 9C19 5 16 2 12 2Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M10 22H14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Ruler - remplace 📏
export const RulerIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="8" width="20" height="8" rx="1" stroke={color} strokeWidth="1.5"/>
    <path d="M6 8V12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 8V11" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14 8V12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M18 8V11" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Target - remplace 🎯
export const TargetIcon = ({ size = 24, color = colors.error }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="5" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="2" fill={color}/>
  </svg>
);

// Search - remplace 🔍
export const SearchIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="6" stroke={color} strokeWidth="1.5"/>
    <path d="M14 14L20 20" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Phone - remplace 📱
export const PhoneIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="2" width="12" height="20" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M10 18H14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Smile - remplace 😊
export const SmileIcon = ({ size = 24, color = colors.success }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5"/>
    <circle cx="9" cy="10" r="1" fill={color}/>
    <circle cx="15" cy="10" r="1" fill={color}/>
    <path d="M8 15C9 16 10 17 12 17C14 17 15 16 16 15" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Folder - remplace 📁
export const FolderIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 6C2 5 3 4 4 4H9L11 6H20C21 6 22 7 22 8V18C22 19 21 20 20 20H4C3 20 2 19 2 18V6Z" 
          fill={color} opacity="0.2"/>
    <path d="M2 6C2 5 3 4 4 4H9L11 6H20C21 6 22 7 22 8V18C22 19 21 20 20 20H4C3 20 2 19 2 18V6Z" 
          stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

// Alert - remplace 🚨
export const AlertIcon = ({ size = 24, color = colors.error }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 20H22L12 2Z" fill={color} opacity="0.2"/>
    <path d="M12 2L2 20H22L12 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M12 10V14" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="17" r="1" fill={color}/>
  </svg>
);

// Lock - remplace 🔒
export const LockIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="10" width="14" height="10" rx="2" stroke={color} strokeWidth="1.5"/>
    <path d="M8 10V7C8 5 10 3 12 3C14 3 16 5 16 7V10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="12" cy="15" r="1.5" fill={color}/>
  </svg>
);

// Hourglass - remplace ⏳
export const HourglassIcon = ({ size = 24, color = colors.secondary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2H18V6L12 12L6 6V2Z" fill={color} opacity="0.2"/>
    <path d="M6 2H18V6L12 12L6 6V2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M6 22H18V18L12 12L6 18V22Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

// Dice - remplace 🎲
export const DiceIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="3" stroke={color} strokeWidth="1.5"/>
    <circle cx="8" cy="8" r="1.5" fill={color}/>
    <circle cx="12" cy="12" r="1.5" fill={color}/>
    <circle cx="16" cy="16" r="1.5" fill={color}/>
  </svg>
);

// QuestionMark - remplace ❓
export const QuestionIcon = ({ size = 24, color = colors.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5"/>
    <path d="M9 9C9 7 10.5 6 12 6C13.5 6 15 7 15 9C15 11 12 11 12 14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="12" cy="17" r="1" fill={color}/>
  </svg>
);

export default {
  ChefIcon,
  WarningIcon,
  DeleteIcon,
  EditIcon,
  CameraIcon,
  CelebrationIcon,
  CheckIcon,
  CloseIcon,
  FleurDeLysIcon,
  FireIcon,
  ClockIcon,
  MealIcon,
  PeanutIcon,
  DairyIcon,
  FishIcon,
  ShellfishIcon,
  EggIcon,
  WheatIcon,
  TreeNutIcon,
  MoveIcon,
  UsersIcon,
  VegetarianIcon,
  VeganIcon,
  CarnivoreIcon,
  KetoIcon,
  PaleoIcon,
  LowCarbIcon,
  HalalIcon,
  KosherIcon,
  SoyIcon,
  SesameIcon,
  SulfitesIcon,
  VideoIcon,
  GiftIcon,
  ClapperboardIcon,
  BreakfastIcon,
  PersonIcon,
  KeyIcon,
  SaveIcon,
  MegaphoneIcon,
  CalendarIcon,
  ForkKnifeIcon,
  DoorIcon,
  StarIcon,
  ChartIcon,
  CommentIcon,
  RefreshIcon,
  UploadIcon,
  PlusIcon,
  DownloadIcon,
  SpoonIcon,
  NoteIcon,
  EyeIcon,
  EyeOffIcon,
  DiamondIcon,
  SettingsIcon,
  LightbulbIcon,
  RulerIcon,
  TargetIcon,
  SearchIcon,
  PhoneIcon,
  SmileIcon,
  FolderIcon,
  AlertIcon,
  LockIcon,
  HourglassIcon,
  DiceIcon,
  QuestionIcon,
};
